export default function restaurant() {
  return [
    'listMenu',
    'pdfMenu',
    'menuGrid',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/restaurant.js